export const formatMotivoVisita = (
  motivoVisita: ReadonlyArray<string>,
  buscaAtiva: ReadonlyArray<string>,
  acompanhamento: ReadonlyArray<string>,
  controleAmbiental: ReadonlyArray<string>
) => [...motivoVisita, ...buscaAtiva, ...acompanhamento, ...controleAmbiental].join('; ')
